import { Avatar, AvatarFallback, Tooltip } from "@heroui/react";
import { getUserInitials } from "@/utils";
import { getColorForId } from "@/utils/avatars";
import { User } from "lucide-react";
import { cn } from "@/utils/cn";

export const colorBorderClass = {
  danger: "border-danger",
  accent: "border-accent",
  success: "border-success",
  warning: "border-warning",
  // secondary: "border-secondary",
  // tertiary: "border-tertiary",
  // default: "border-default",
};

const ColorAvatar = ({ id, name, color, size = "sm", className = "" }) => {
  const resolvedColor = color ?? getColorForId(id);
  const borderClass = colorBorderClass[resolvedColor] ?? "border-success";


  const handleSize = () => {
    if(size === 'xs'){
      return 'size-5! text-[8px]!'
    } else {
      return 'size-7! text-sm'
    }
  }

  return (
    <div className={`relative inline-flex shrink-0 ${className}`}>
      <div className="absolute inset-0 rounded-full bg-surface" />

      <Tooltip delay={0.1}>
        <Tooltip.Trigger>
          <Avatar size={size} variant="soft" className={cn(`relative border-2 lg:border-[1px] ${borderClass}`, handleSize())}>
            <AvatarFallback color={resolvedColor} className={size === "lg" ? "font-bold" : "text-[9px]"}>
              {getUserInitials(name).toUpperCase()}
            </AvatarFallback>
          </Avatar>
        </Tooltip.Trigger>
        <Tooltip.Content className={"capitalize text-xs items-center flex-row"}>
          <div className="flex items-center font-medium gap-1">
            <User size={16} strokeWidth={1.5} className="text-accent"/>
            {name}
          </div>
        </Tooltip.Content>
      </Tooltip>
    </div>
  );
};

export default ColorAvatar;
